"use strict";

var _require = require('../../products/interfaces'),
    PaperComponent = _require.PaperComponent;

function isPaperComponent(component) {
  return Object.prototype.isPrototypeOf.call(PaperComponent.prototype, component);
}

module.exports = isPaperComponent;